import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../api/query-keys';
import { useAuth } from '../../../auth/AuthProvider';
import { getDocument, getImageEvidence, listMachineDocuments } from './documents.api';
import { isDocumentActivelyLearning } from '../types/document';

export function useDocuments(
  machineId: string,
  enabled = true,
  lifecycleStatus: 'ACTIVE' | 'REMOVED' = 'ACTIVE',
) {
  const auth = useAuth();
  return useQuery({
    queryKey: queryKeys.documents(auth.activeCustomerId, machineId, lifecycleStatus),
    queryFn: () => listMachineDocuments(machineId, lifecycleStatus),
    enabled: Boolean(enabled && auth.activeCustomerId && machineId),
    refetchInterval: (query) => {
      const data = query.state.data;
      return data?.documents.some(isDocumentActivelyLearning) ? 3000 : false;
    },
  });
}

export function useDocument(documentId: string, enabled = true) {
  const auth = useAuth();
  return useQuery({
    queryKey: queryKeys.document(auth.activeCustomerId, documentId),
    queryFn: () => getDocument(documentId),
    enabled: Boolean(enabled && auth.activeCustomerId && documentId),
    refetchInterval: (query) => {
      const document = query.state.data;
      return document && isDocumentActivelyLearning(document) ? 3000 : false;
    },
  });
}


export function useImageEvidence(documentId: string, enabled = true) {
  const auth = useAuth();
  return useQuery({
    queryKey: queryKeys.imageEvidence(auth.activeCustomerId, documentId),
    queryFn: () => getImageEvidence(documentId),
    enabled: Boolean(enabled && auth.activeCustomerId && documentId),
    staleTime: 60_000,
    retry: 1,
  });
}
